// extracted by mini-css-extract-plugin
export default {"validationErrorFlash":"IssueBodyEditor-module__validationErrorFlash--xB10i"};